// Libraries
import { observable } from "mobx";

// Core
import { ModelBase } from "Core/Models/ModelBase";
import { Seamsil100Model, Seamsil100ModelDTO } from "./SeamsilProductModels/Seamsil100";

export class SeamsilProductsModel extends ModelBase<SeamsilProductsModel, SeamsilProductsModelDTO> {
    private seamsil100Model: Seamsil100Model;

    constructor() {
        super();

        this.seamsil100Model = new Seamsil100Model();

        this.products.push({ title: "Seamsil 100", value: "id_seamsilsubstrateundefined" });

        this.productSelection = this.products[0];
    }

    // #region Model Properties

    public get Seamsil100Model(): Seamsil100Model {
        return this.seamsil100Model;
    }

    @observable
    public products = observable<any>([]);

    @observable
    public productSelection: any = undefined;

    // #endregion Model Properties

    public fromDto(model: SeamsilProductsModelDTO): void {
        throw new Error("Method not implemented.");
    }

    public toDto(): SeamsilProductsModelDTO {
        return {
            seamsil100: this.productSelection.value === "id_seamsilsubstrateundefined" ? this.Seamsil100Model.toDto() : undefined,
        };
    }
}

export interface SeamsilProductsModelDTO {
    seamsil100?: Seamsil100ModelDTO;
}
